<template>
  <Dialog
    v-model:visible="mostrarModal"
    :style="{ width: '650px' }"
    header="Vehículo Detalle"
    :modal="true"
    :maximizable="true"
    class="p-fluid"
    @hide="ocultarDialog"
  >
    <div class="col-12">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-4" v-if="!data_vehiculo.nombre_cliente">
          <span><strong>SELECCIONE CLIENTE: </strong><span class="p-invalid">*</span></span>
          <div class="p-inputgroup">
            <Dropdown
              v-model="clienteSelected"
              :options="clientes"
              optionLabel="nombre"
              optionValue="id"
              placeholder="Seleccione un cliente..."
              :filter="true"
            />
            <Button icon="pi pi-user" class="p-button-info" v-tooltip.top="'Nuevo Cliente'" @click="activarCliente" />
          </div>
          <small class="p-invalid" v-if="errors.cliente">{{ errors.cliente[0] }}</small>
        </div>

        <div class="field col-12 md:col-4">
          <span><strong>TAMAÑO: </strong><span class="p-invalid">*</span></span>
          <Dropdown
            v-model="tamanioSelected"
            :options="tamanios"
            optionLabel="label"
            optionValue="value"
            placeholder="Seleccione un tamaño..."
          />
          <small class="p-invalid" v-if="errors.tamanio">{{ errors.tamanio[0] }}</small>
        </div>

        <div class="field col-12 md:col-4">
          <span><strong>PLACA: </strong><span class="p-invalid">*</span></span>
          <InputText v-model.trim="data_vehiculo.placa" v-uppercase placeholder="Ej: ABC1234" />
          <small class="p-invalid" v-if="errors.placa">{{ errors.placa[0] }}</small>
        </div>

        <div :class="data_vehiculo.id ? 'field col-12 md:col-3' : 'field col-12 md:col-4'">
          <span><strong>MARCA: </strong></span>
          <div class="p-inputgroup">
            <Dropdown
              v-model="marcaSelected"
              :options="marcas"
              optionLabel="nombre"
              optionValue="id"
              placeholder="Seleccione una marca..."
              :filter="true"
              @change="filtrarModelos"
            />
            <Button icon="pi pi-plus" class="p-button-info" v-tooltip.top="'Nueva Marca'" @click="activarMarca" />
          </div>
          <small class="p-invalid" v-if="errors.marca">{{ errors.marca[0] }}</small>
        </div>

        <div :class="data_vehiculo.id ? 'field col-12 md:col-3' : 'field col-12 md:col-4'">
          <span><strong>MODELO: </strong></span>
          <div class="p-inputgroup">
            <Dropdown
              v-model="modeloSelected"
              :options="modelosFiltrados"
              optionLabel="nombre"
              optionValue="id"
              placeholder="Seleccione un modelo..."
              :filter="true"
            />
            <Button icon="pi pi-plus" class="p-button-info" v-tooltip.top="'Nuevo Modelo'" @click="activarModelo" />
          </div>
          <small class="p-invalid" v-if="errors.modelo">{{ errors.modelo[0] }}</small>
        </div>

        <div :class="data_vehiculo.id ? 'field col-12 md:col-3' : 'field col-12 md:col-4'">
          <span><strong>COLOR: </strong></span>
          <Textarea v-model.trim="data_vehiculo.color" placeholder="Color" rows="1" autoResize />
          <small class="p-invalid" v-if="errors.color">{{ errors.color[0] }}</small>
        </div>

        <div class="field col-12 md:col-3" v-if="data_vehiculo.id">
          <span><strong>ESTADO: </strong><span class="p-invalid">*</span></span>
          <Dropdown
            v-model="data_vehiculo.estado"
            :options="estados"
            optionLabel="label"
            placeholder="Seleccione un estado..."
          >
            <template #value="slotProps">
              <span :class="'product-badge ' + claseEstado[slotProps.value?.value ?? slotProps.value]">
                {{ slotProps.value?.label ?? (slotProps.value == 1 ? 'ACTIVO' : 'INACTIVO') }}
              </span>
            </template>
          </Dropdown>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="field">
        <span class="flex md:justify-content-start">
          <strong>CAMPOS REQUERIDOS: </strong><span class="p-invalid">*</span>
        </span>
      </div>
      <Button label="CANCELAR" icon="pi pi-times" class="p-button-secondary p-button-lg" @click="ocultarDialog" />
      <Button
        :disabled="!clienteSelected"
        :label="data_vehiculo.id ? 'ACTUALIZAR' : 'GUARDAR'"
        icon="pi pi-save"
        class="p-button-info p-button-lg"
        :loading="enviado"
        @click="saveVehiculo"
      />
    </template>
  </Dialog>

  <ClienteCreate
    v-if="clienteModal"
    :show="clienteModal"
    :cliente="cliente"
    @closeModal="cerrarModalCliente"
    @actualizarListado="cargarClientesListado"
  />

  <MarcaCreate
    v-if="marcaModal"
    :show="marcaModal"
    :marca="marca"
    @closeModal="cerrarModalMarca"
    @actualizarListadoMarca="getMarcaListado"
  />

  <ModeloCreate
    v-if="modeloModal"
    :show="modeloModal"
    :modelo="modelo"
    :marcas="marcas"
    @closeModal="cerrarModalModelo"
    @actualizarListadoModelo="getModeloListado"
  />
</template>

<script>
import VehiculoService from '@/service/VehiculoService'
import ClienteService from '@/service/ClienteService'
import ClienteCreate from '@/module/clientes/ClienteCreate.vue'
import MarcaCreate from '@/module/vehiculos/MarcaCreate.vue'
import ModeloCreate from '@/module/vehiculos/ModeloCreate.vue'

export default {
  components: { ClienteCreate, MarcaCreate, ModeloCreate },

  emits: ['closeModalVehiculo', 'actualizarListadoVehiculo'],

  props: {
    show: { type: Boolean, default: false },
    vehiculo: { type: Object, default: () => ({}) }
  },

  data() {
    return {
      mostrarModal: this.show,
      data_vehiculo: { ...this.vehiculo },
      enviado: false,
      errors: {},
      tamanioSelected: null,
      clienteSelected: null,
      marcaSelected: null,
      modeloSelected: null,
      clientes: [],
      marcas: [],
      modelos: [],
      modelosFiltrados: [],
      clienteModal: false,
      cliente: {},
      marcaModal: false,
      marca: {},
      modeloModal: false,
      modelo: {},
      estados: [
        { label: 'ACTIVO', value: 1 },
        { label: 'INACTIVO', value: 0 }
      ],
      tamanios: [
        { label: 'PEQUEÑO', value: 1 },
        { label: 'MEDIANO', value: 2 },
        { label: 'GRANDE', value: 3 },
        { label: 'OTRO', value: 4 }
      ],
      claseEstado: ['status-outofstock', 'status-instock']
    }
  },

  created() {
    this.vehiculoService = new VehiculoService()
    this.clienteService = new ClienteService()
  },

  mounted() {
    this.cargarDatosNecesarios()
  },

  methods: {
    cargarDatosNecesarios() {
      this.vehiculoService
        .getVehiculoDatosNecesarios()
        .then((response) => {
          this.marcas = response.marcas ?? []
          this.modelos = response.modelos ?? []
          this.clientes = response.clientes ?? []

          if (this.data_vehiculo.id) {
            this.precargarSelects(this.data_vehiculo)
          } else if (this.clientes.length > 0) {
            this.clienteSelected = this.clientes[0].id
          }
        })
        .catch((error) => {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al cargar datos: ' + error.message,
            life: 3000
          })
        })
    },

    precargarSelects(val) {
      this.clienteSelected = val.cliente_id ?? null
      this.marcaSelected = parseInt(val.marca) || null
      this.modeloSelected = parseInt(val.modelo) || null
      this.tamanioSelected = parseInt(val.tamanio) || null
      this.filtrarModelos()
    },

    filtrarModelos() {
      this.modelosFiltrados = this.modelos.filter((m) => m.marca_id == this.marcaSelected)
      const existe = this.modelosFiltrados.find((m) => m.id == this.modeloSelected)
      if (!existe) this.modeloSelected = null
    },

    activarMarca() {
      this.marca = { estado: { label: 'Activo', value: 1 } }
      this.marcaModal = true
    },
    cerrarModalMarca() {
      this.marcaModal = false
      this.marca = {}
    },
    getMarcaListado(marcaNueva = null) {
      this.vehiculoService.getMarcasAll().then((response) => {
        this.marcas = response.marcas ?? []
        if (marcaNueva) {
          this.marcaSelected = marcaNueva.id
          this.filtrarModelos()
        }
      })
    },

    activarModelo() {
      this.modelo = { estado: { label: 'Activo', value: 1 }, marca_id: this.marcaSelected ?? null }
      this.modeloModal = true
    },
    cerrarModalModelo() {
      this.modeloModal = false
      this.modelo = {}
    },
    getModeloListado(modeloNuevo = null) {
      this.vehiculoService.getModelosAll().then((response) => {
        this.modelos = response.modelos ?? []
        this.filtrarModelos()
        if (modeloNuevo) this.modeloSelected = modeloNuevo.id
      })
    },

    activarCliente() {
      this.cliente = { estado: { label: 'Activo', value: 1 }, tipo_cliente: 0 }
      this.clienteModal = true
    },
    cerrarModalCliente() {
      this.clienteModal = false
      this.cliente = {}
    },
    cargarClientesListado(clienteNuevo = null) {
      this.clienteService.getClientesAll().then((response) => {
        this.clientes = response ?? []
        if (clienteNuevo) this.clienteSelected = clienteNuevo.id
      })
    },

    ocultarDialog() {
      this.errors = {}
      this.enviado = false
      this.mostrarModal = false
      this.$emit('closeModalVehiculo')
    },

    validacionesForm() {
      this.errors = {}
      if (!this.data_vehiculo.placa) this.errors.placa = ['Placa es requerida']
      if (!this.clienteSelected) this.errors.cliente = ['Cliente es requerido']
      if (!this.tamanioSelected) this.errors.tamanio = ['Tamaño es requerido']
      return Object.keys(this.errors).length === 0
    },

    async saveVehiculo() {
      this.errors = {}
      this.enviado = true

      if (!this.validacionesForm()) {
        this.enviado = false
        return
      }

      try {
        if (this.data_vehiculo.id) {
          const payload = {
            ...this.data_vehiculo,
            estado: this.data_vehiculo.estado?.value ?? this.data_vehiculo.estado,
            cliente_id: this.clienteSelected,
            tamanioSelected: this.tamanioSelected,
            marca: this.marcaSelected ?? null,
            modelo: this.modeloSelected ?? null
          }
          const data = await this.vehiculoService.updateVehiculo(payload)
          if (data?.errors) {
            this.errors = data.errors
          } else {
            this.$toast.add({ severity: 'success', summary: '¡Éxito!', detail: data.mensaje, life: 3000 })
            this.$emit('actualizarListadoVehiculo', data.vehiculo)
            this.ocultarDialog()
          }
        } else {
          const payload = {
            ...this.data_vehiculo,
            cliente_id: this.clienteSelected,
            tamanioSelected: this.tamanioSelected,
            estado: 1,
            marca: this.marcaSelected ?? null,
            modelo: this.modeloSelected ?? null
          }
          const data = await this.vehiculoService.sendVehiculoNew(payload)
          if (data?.errors) {
            this.errors = data.errors
          } else if (data?.status == 400) {
            this.$toast.add({ severity: 'error', summary: 'Error', detail: data.mensaje, life: 5000 })
          } else {
            this.$toast.add({ severity: 'success', summary: '¡Éxito!', detail: data.mensaje, life: 3000 })
            this.$emit('actualizarListadoVehiculo', data.vehiculo)
            this.ocultarDialog()
          }
        }
      } catch (error) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Ocurrió un error al guardar', life: 5000 })
      } finally {
        this.enviado = false
      }
    }
  },

  watch: {
    show(val) {
      this.mostrarModal = val
      if (!val) this.enviado = false
    },

    vehiculo(val) {
      this.data_vehiculo = { ...val }
      if (val.id) {
        if (this.marcas.length > 0) this.precargarSelects(val)
      } else {
        this.clienteSelected = this.clientes.length > 0 ? this.clientes[0].id : null
        this.marcaSelected = null
        this.modeloSelected = null
        this.tamanioSelected = null
        this.modelosFiltrados = []
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/demo/badges.scss';
.p-invalid {
  color: red;
}
</style>
